import React, { useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { useLang } from "@/context/LanguageContext";
import { X, Flag } from "lucide-react";

const MOTIFS = ["spam", "harassment", "hate", "ads", "scam", "dangerous", "fake", "offtopic", "other"];

export default function ReportDialog({ targetType, targetId }) {
  const { t } = useLang();
  const [open, setOpen] = useState(false);
  const [motif, setMotif] = useState("spam");
  const [detail, setDetail] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    setBusy(true);
    try {
      await api.post("/community/report", { target_type: targetType, target_id: targetId, motif, detail });
      toast.success(t("com_report_sent"));
      setOpen(false); setDetail("");
    } catch { toast.error(t("com_error")); } finally { setBusy(false); }
  };

  return (
    <>
      <button data-testid={`report-btn-${targetId}`} onClick={() => setOpen(true)} className="inline-flex items-center gap-1 text-xs text-stone-500 hover:text-red-400">
        <Flag className="w-3.5 h-3.5" /> {t("com_report")}
      </button>
      {open && (
        <div className="fixed inset-0 z-[1200] flex items-center justify-center bg-black/70 p-4" onClick={() => setOpen(false)}>
          <div className="w-full max-w-sm bg-[#121418] border border-[#272A34] rounded-xl p-5" onClick={(e) => e.stopPropagation()} data-testid="report-dialog">
            <div className="flex items-center justify-between mb-4"><h3 className="font-serif text-lg text-amber-100">{t("com_report")}</h3><button onClick={() => setOpen(false)}><X className="w-5 h-5 text-stone-400" /></button></div>
            <label className="block text-xs font-mono uppercase tracking-wider text-stone-500 mb-1">{t("com_report_motif")}</label>
            <select data-testid="report-motif" value={motif} onChange={(e) => setMotif(e.target.value)} className="w-full bg-[#0B0C0E] border border-[#272A34] rounded-md px-3 py-2.5 text-sm text-stone-200 mb-3">
              {MOTIFS.map((m) => <option key={m} value={m}>{t(`com_report_${m}`)}</option>)}
            </select>
            <textarea data-testid="report-detail" rows={3} value={detail} onChange={(e) => setDetail(e.target.value)} placeholder={t("com_report_detail")} className="w-full bg-[#0B0C0E] border border-[#272A34] rounded-md px-3 py-2.5 text-sm text-stone-200 resize-none mb-3" />
            <button data-testid="report-submit" onClick={submit} disabled={busy} className="w-full bg-red-900/70 hover:bg-red-800 text-white px-4 py-2 rounded-md text-sm font-medium disabled:opacity-50">{t("com_send")}</button>
          </div>
        </div>
      )}
    </>
  );
}
